
import ToolHeader from "../../Components/ToolHeader";
import "../JSONTools/JSONformatter.css";
import { Row, Col } from "react-bootstrap";
import "./ImagePdfTools.css";
import { useState, useRef } from "react";

import { ReactComponent as CopyIcon } from "../../Icons/Copy.svg";
import { ReactComponent as DeleteIcon } from "../../Icons/Delete.svg";
import { Base64toImageAPI, ImagetoBase64API } from "../../Services/APIService";

const FORMAT_OPTIONS = [
    "Image ➜ Base64",
    "Base64 ➜ Image",
];

const tabs = [
    "Raw Base64",
    "Data URL",
    "Image",
    "CSS",
    "Full CSS",
    "Markdown",
    "JSON",
];

function Base64ImageTools() {
    const [selectedFormat, setSelectedFormat] = useState("Image ➜ Base64");

    const [files, setFiles] = useState([]);
    const [activeTab, setActiveTab] = useState("Raw Base64");
    const [showCode, setShowCode] = useState(true);
    const [iscopied, setIsCopied] = useState(false);
    const [isDownload, setIsDownload] = useState(false);
    const [imageFormat, setImageFormat] = useState("");

    // BASE64 ➜ IMAGE
    const [base64Input, setBase64Input] = useState("");
    const [decodedImage, setDecodedImage] = useState("");
    const [decodeError, setDecodeError] = useState("");

    const fileInputRef = useRef(null);

    const toolFav = {
        toolName: "Base64 Image Converter",
        Iconpath: "/FileCodeRaw.svg"
    };

    

    

    const convertFileToBase64 = async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file);

            const response = await ImagetoBase64API(formData);
            const responseData = response?.data;

            let base64 = "";
            let contentType = file.type || "image/png";
            let fileName = file.name || "decoded-image.png";
            base64 = await responseData.text();
            base64 = JSON.parse(base64).base64Image || JSON.parse(base64).data || base64;
            base64 = String(base64).trim();
            base64 = base64.replace(/\s+/g, "");
            const dataUrl = base64.startsWith("data:")
                ? base64
                : `data:${contentType};base64,${base64}`;

            return { base64, dataUrl, contentType, fileName };
        } catch (error) {
            console.error("Image to base64 conversion failed:", error);
            throw error;
        }
    };

    const handleFileChange = async (e) => {
        const selectedFiles = Array.from(e.target.files || []);
        const processedFiles = [];

        for (const file of selectedFiles) {
            if (!file.type.startsWith("image/")) continue;

            try {
                const preview = URL.createObjectURL(file);
                const { base64, dataUrl, contentType, fileName } = await convertFileToBase64(file);

                processedFiles.push({
                    id: Date.now() + Math.random(),
                    file,
                    preview,
                    base64,
                    dataUrl,
                    contentType,
                    fileName
                });
            } catch (error) {
                console.error("Failed to process file:", error);
            }
        }

        setFiles((prev) => [...prev, ...processedFiles]);
    };

    const handleDrop = async (e) => {

        e.preventDefault();

        const droppedFiles = e.dataTransfer.files;

        const fakeEvent = {
            target: {
                files: droppedFiles
            }
        };

        await handleFileChange(fakeEvent);
    };

    const removeFile = (id) => {
        setFiles((prev) => {
            const target = prev.find((f) => f.id === id);
            if (target?.preview) {
                URL.revokeObjectURL(target.preview);
            }
            return prev.filter((f) => f.id !== id);
        });
    };

    const getTabContent = (item) => {

        switch (activeTab) {

            case "Raw Base64":
                return item.base64;

            case "Data URL":
                return item.dataUrl;

            case "Image":
                return `<img src="${item.dataUrl}" alt="${item.file.name}" />`;

            case "CSS":
                return `background-image:url("${item.dataUrl}");`;

            case "Full CSS":
                return `.image {\n  background-image:url("${item.dataUrl}");\n  background-size:cover;\n}`;

            case "Markdown":
                return `![${item.file.name}](${item.dataUrl})`;

            case "JSON":
                return JSON.stringify(
                    {
                        fileName: item.file.name,
                        base64: item.base64
                    },
                    null,
                    2
                );

            default:
                return item.base64;
        }
    };

    const copyText = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error(err);
        }
        setTimeout(() => {
            setIsCopied(false);
        }, 3000);
        setIsCopied(true);
    };

    // BASE64 ➜ IMAGE
    const processBase64 = async (value) => {
        setBase64Input(value);
        if (!value.trim()) {
            setDecodedImage("");
            setDecodeError("");
            return;
        }
        try {
            const cleanedValue = String(value).trim().replace(/\s+/g, "");
            const base64Image = cleanedValue.startsWith("data:")
                ? cleanedValue.split(",")[1] || cleanedValue
                : cleanedValue;
            const payload = {
                base64Image: base64Image,
                outputFormat: "png"
            };

            const response = await Base64toImageAPI(payload);
            const responseData = response?.data;

            let imageUrl = "";

            if (responseData instanceof Blob) {
                imageUrl = URL.createObjectURL(responseData);
            } else if (typeof responseData === "string") {
                imageUrl = responseData;
            } else if (responseData && typeof responseData === "object") {
                const imagePayload = responseData.base64Image || responseData.image || responseData.data || "";
                const imageFormat = responseData.imageFormat || responseData.contentType || "image/png";

                if (typeof imagePayload === "string" && imagePayload) {
                    imageUrl = imagePayload.startsWith("data:")
                        ? imagePayload
                        : `data:${imageFormat};base64,${imagePayload}`;
                }
            }

            if (!imageUrl) {
                throw new Error("No image returned from API");
            }

            setDecodedImage(imageUrl);
            setDecodeError("");
            setImageFormat(responseData.imageFormat);
        } catch (e) {
            console.error("Base64 to image conversion failed:", e);
            setDecodedImage("");
            setDecodeError("Invalid Base64 image");
        }
    };

    const downloadDecodedImage = () => {
        if (!decodedImage) return;
        const a = document.createElement("a");
        a.href = decodedImage;
        a.download = "decoded-image.png";
        a.click();
        setTimeout(() => {
            setIsDownload(false);
        }, 3000);
        setIsDownload(true);
    };

    return (
        <Col>

            {/* HEADER */}
            <ToolHeader title="Base64 Image Converter" description="Convert and resize images all processing happens in your browser" toolFav={toolFav} />

            {/* FORMAT TABS */}
            <Row>

                <div className="format-tabs ActionButtons">
                    {FORMAT_OPTIONS.map((item) => (
                        <button
                            key={item}
                            className={`format-btn ${selectedFormat === item
                                ? "active"
                                : ""
                                }`}
                            onClick={() => setSelectedFormat(item)}
                        >
                            {item}
                        </button>

                    ))}

                </div>

            </Row>

            <Row className='Formatter'>

                <div className="converter-wrapper">

                    {/* IMAGE ➜ BASE64 */}
                    {selectedFormat === "Image ➜ Base64" && (
                        <>

                            {/* DROP ZONE */}
                            <label
                                className="drop-zone"
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}
                            >

                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    accept="image/*"
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                />

                                <div className="upload-content">

                                    <div className="upload-icon">
                                        <svg
                                            className="dmc-upload-icon"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M12 16V4M12 4L7 9M12 4L17 9" />
                                            <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
                                        </svg>
                                    </div>

                                    <p>
                                        Click to select or drop images here
                                    </p>

                                    <span>
                                        Supports JPG, PNG, GIF, WebP, SVG
                                        <br />
                                        (Maximum 20 files)
                                    </span>

                                </div>

                            </label>

                            {/* RESULTS */}
                            {files.length > 0 && (

                                <div className="results-card">

                                    {/* HEADER */}
                                    <div className="results-header">

                                        <div className="results-title">
                                            Encoding Results
                                        </div>

                                        <div className="results-status">

                                            <span className="status-pill">
                                                Completed
                                            </span>

                                            <span className="status-text">
                                                {files.length} file(s) converted successfully
                                            </span>

                                        </div>

                                    </div>

                                    {/* CLEAR */}
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            padding: "12px"
                                        }}
                                    >

                                    </div>

                                    {/* FILE ITEMS */}
                                    {files.map((item) => (

                                        <div
                                            key={item.id}
                                            className="file-card"
                                        >

                                            {/* TOP */}
                                            <div className="file-top">

                                                <div className="file-info">

                                                    <img
                                                        src={item.preview}
                                                        alt="preview"
                                                        className="file-thumb"
                                                    />

                                                    <div>

                                                        <div className="file-name">
                                                            {item.file.name}
                                                        </div>

                                                        <div className="file-meta">
                                                            {(
                                                                item.file.size /
                                                                1024
                                                            ).toFixed(2)} KB
                                                        </div>

                                                    </div>

                                                </div>

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "10px"
                                                    }}
                                                >

                                                    <button
                                                        className="hide-btn"
                                                        onClick={() =>
                                                            setShowCode(!showCode)
                                                        }
                                                    >
                                                        {"</>"} {showCode ? "Hide" : "Show"}
                                                    </button>

                                                    <button
                                                        className="hide-btn"
                                                        onClick={() =>
                                                            removeFile(item.id)
                                                        }
                                                    >
                                                        <DeleteIcon />
                                                    </button>

                                                </div>

                                            </div>

                                            {/* PREVIEW */}
                                            <div className="preview-wrapper">
                                                <img
                                                    src={item.preview}
                                                    alt="output"
                                                    className="preview-image"
                                                />
                                            </div>

                                            {/* TABS */}
                                            <div className="tabs-row">
                                                {tabs.map((tab) => (
                                                    <button
                                                        key={tab}
                                                        className={`tab-btn ${activeTab === tab
                                                            ? "active-tab"
                                                            : ""
                                                            }`}
                                                        onClick={() =>
                                                            setActiveTab(tab)
                                                        }
                                                    >
                                                        {tab}
                                                    </button>
                                                ))}
                                                <button
                                                    className="image-copy-btn"
                                                    onClick={() =>
                                                        copyText(
                                                            getTabContent(item)
                                                        )
                                                    }
                                                >
                                                    <CopyIcon />
                                                    <span>{iscopied ? "Copied!" : "Copy"}</span>
                                                </button>
                                            </div>
                                            {/* CODE */}
                                            {showCode && (
                                                <div className="code-box">
                                                    <pre>
                                                        {getTabContent(item)}
                                                    </pre>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                        </>
                    )}

                    {/* BASE64 ➜ IMAGE */}
                    {selectedFormat === "Base64 ➜ Image" && (

                        <div className="results-card">

                            <div className="results-header">

                                <div className="results-title">
                                    Base64 Preview
                                </div>

                            </div>

                            {/* INPUT */}
                            <div style={{ padding: "16px" }}>

                                <textarea
                                    value={base64Input}
                                    onChange={(e) =>
                                        processBase64(e.target.value)
                                    }
                                    placeholder="Paste Base64 string here..."
                                    className="base64-input"
                                    style={{
                                        minHeight: "180px"
                                    }}
                                />

                                {decodeError && (
                                    <div
                                        style={{
                                            color: "red",
                                            marginTop: "10px"
                                        }}
                                    >
                                        {decodeError}
                                    </div>
                                )}

                            </div>

                            {/* OUTPUT */}
                            {decodedImage && (

                                <div className="file-card">

                                    <div className="file-top">

                                        <div className="file-name">
                                            Decoded Image
                                        </div>

                                        <button
                                            className="ExecuteButton"
                                            onClick={downloadDecodedImage}
                                        >
                                            {isDownload ? "Downloaded!" : "Download"}
                                        </button>

                                    </div>

                                    <div className="preview-wrapper">
                                        <div className="decoded-image-container">
                                            <img
                                                src={decodedImage}
                                                alt="decoded"
                                                className="preview-image"
                                            />
                                        </div>

                                    </div>
                                    <p>Detected Format: {imageFormat}</p>
                                </div>

                            )}

                        </div>

                    )}

                </div>

            </Row>

        </Col>
    );
}

export default Base64ImageTools;

